module.exports = __webpack_public_path__ + "static/led-screen-b-4589cf9619c98c0c7ef9e75a76e5c2b6.jpg";